wc.service.declare({
	id: "AjaxPetcoGetLocation",
	actionId: "AjaxPetcoGetLocation",
	url: getAbsoluteURL() + "AjaxPetcoGetLocation",
	formId: ""

		,
	successHandler: function (serviceResponse) {
			var formattedCity = serviceResponse.city != null ? serviceResponse.city : '';
			var domain = "";
			if (dojo.byId('cookieDomain') != null) {
				domain = dojo.byId('cookieDomain').value;
			} else {
				domain = '.petco.com';
			}
			dojo.cookie("petco-us-city", formattedCity, {
				path: "/",
				domain: domain
			});
			dojo.topic.publish('cookieAddedForPhysicalStoreId', formattedCity);
		}

		,
	failureHandler: function (serviceResponse) {

		console.log("Error in AjaxPetcoGetLocation. " + serviceResponse.errorMessage);
	}

})

var petcoLocation = (function () {

	var _petcoUSCityCookieName = 'petco-us-city'
	_akamaiCookie = 'Edgescape-City';

	function doesCookieExist(cookieName) {
		var cookieValue = getCookie(cookieName),
			doesCookieExist = false;

		if (cookieValue != null && cookieValue != '') {
			doesCookieExist = true;
		}

		return doesCookieExist;
	}

	function populateCity() {
		var petcoUSCityCookieValue = getCookie(_petcoUSCityCookieName) != null ? getCookie(_petcoUSCityCookieName) : '',
			isMobile = window.matchMedia("(max-width: 768px)").matches;

		var headerCityValue = 'Local',
			sPhysicalStoreName ,
			bodyCityValue = 'local';
		if (petcoUSCityCookieValue) {
			petcoUSCityCookieValue = petcoUSCityCookieValue.replace(/%20/g, " ");
			if (!isMobile || petcoUSCityCookieValue.length < 15) {
				headerCityValue = petcoUSCityCookieValue;
			}
			bodyCityValue = petcoUSCityCookieValue;
		}
		$('.petco-us-city-upper').html(headerCityValue);
		$('.petco-us-city-lower').html(bodyCityValue);
		$('.petco-us-city-upper-full').html(bodyCityValue);
		var userId = dojo.cookie("WC_UserId");
		var nearestStoreKey = 'nearestStore_' + userId;
		var updateHeader = false;
		LOCALSTORAGE_STORES_KEY = 'petcostores';
		if (null != localStorage.getItem(LOCALSTORAGE_STORES_KEY)) {
			oNearestStores = JSON.parse(localStorage.getItem(LOCALSTORAGE_STORES_KEY));
			if (oNearestStores != null && typeof (oNearestStores.petcostores) != 'undefined') {
				aPetcostores = JSON.parse(oNearestStores.petcostores);
				if (aPetcostores != undefined && aPetcostores != null) {
					oNearestStores = aPetcostores[0];
					sPhysicalStoreName = oNearestStores.DSNAME != 'undefined' ? oNearestStores.DSNAME : sessionStorage.getItem(nearestStoreKey);
					updateHeader = true;

				} else {
					var city = sessionStorage.getItem(nearestStoreKey);
					if (city != null && typeof (city) != 'undefined') {
						sPhysicalStoreName = city;
						updateHeader = true;
					}
				}
			}
		} else {
			var city = sessionStorage.getItem(nearestStoreKey);
			if (city != null && typeof (city) != 'undefined') {
				sPhysicalStoreName = city;
				updateHeader = true;
			}
		}
		if (updateHeader) {
			var fullStoreName = sPhysicalStoreName + " Pet Services";
			sPhysicalStoreName = sPhysicalStoreName.replace(/[\W_]/g, " ").split(/\s+/).slice(0, 2).join(" ");
			var displayName = sPhysicalStoreName;
			if (displayName.length > 10) {
				displayName = displayName.substring(0, 10) + "...";
			}
			$('.petco-us-city-upper-full').html(sPhysicalStoreName);
			$('.petco-us-city-upper').html(displayName);
			$("#pet-services").attr("title", fullStoreName);
		}
	}

	$('.lsa-location').bind('DOMSubtreeModified', function () {
		var newvalue = this.innerHTML;
		if (newvalue && newvalue.indexOf('<br>') !== -1) {
			newvalue = newvalue.split('<br>')[0];

		}
		if (newvalue != "undefined" && newvalue != "") {
			$("#pet-services").attr("title", newvalue + " Pet Services");
			newvalue = newvalue.replace(/[\W_]/g, " ").split(/\s+/).slice(0, 2).join(" ");
			var displayName = newvalue;
			if (displayName.length > 10) {
				displayName = displayName.substring(0, 10) + "...";
			}
			$('.petco-us-city-upper').html(displayName);
			$('.petco-us-city-upper-full').html(newvalue);


		}
	});


	function setPetcoLocationCookie(storeId, catalogId, langId) {
		try {
			var isPetcoLocationCookie = doesCookieExist(_petcoUSCityCookieName), 
				akamaiCookieName = _akamaiCookie, 
				akamaiCookieValue = '',
				params = [];

			params.storeId = storeId;
			params.langId = langId;
			params.catalogId = catalogId;


			if (isPetcoLocationCookie) {
				return false; 
			} else {
				akamaiCookieValue = getCookie(akamaiCookieName); 


				if (akamaiCookieValue != null && akamaiCookieValue != '') {
					params.cityKey = akamaiCookieValue; 
					wc.service.invoke('AjaxPetcoGetLocation', params); 
				}
			}

		} catch (err) {
			console.log("An error has occured in petcoCommonJS.setPetcoLocationCookie. " + err);
		}

	}
	return {
		setPetcoLocationCookie: setPetcoLocationCookie,
		populateCity: populateCity

	};

})();